import { render } from "./AddOn.vue?vue&type=template&id=5b37bc17"
import script from "./AddOn.vue?vue&type=script&lang=js"
export * from "./AddOn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__